export default {"src":"/_next/static/media/en.38cc23c8.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};